module.exports = __webpack_public_path__ + "static/media/bnz.84264b7a.png";